(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class HeaderWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.shopify-section-header');
  }
}
customElements.define('header-wrapper', HeaderWrapper);

class StickyHeader extends HeaderWrapper {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    this.lastScrollTop = 0;
    this.header.classList.add('shopify-section-header-sticky');
    this.isHidden = false;

    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // when scrolling down, hide header after small threshold
    if (scrollTop > this.lastScrollTop && scrollTop > 100) {
      if (!this.isHidden) {
        this.header.classList.add('shopify-section-header-hidden');
        this.isHidden = true;
      }
    } 
    // when scrolling up, show header again
    else {
      if (this.isHidden) {
        this.header.classList.remove('shopify-section-header-hidden');
        this.isHidden = false;
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
